import { defineStore } from "pinia";
import type { TruckReservedWSData } from "@/api/trucks/dto/ws/reserved";
import type { TruckService } from "@/services/socket/truck.service";

type TruckStoreState = {
  truckWSService: TruckService | null;
  truckReservedWS: TruckReservedWSData | null;
};

export const useTruckStore = defineStore("truckStore", {
  state(): TruckStoreState {
    return {
      truckWSService: null,
      truckReservedWS: null,
    };
  },
  actions: {
    setTruckWSService(service: TruckService | null) {
      this.truckWSService = service;
    },
    setTruckReservedWS(data: TruckReservedWSData | null) {
      this.truckReservedWS = data;
    },
  },
});
